/**
 * A fixed point grid (DESIGN.md "Secure Score grid"): `total` 10px squares,
 * 10 to a row with 2px gaps, the earned ones filled with the Secure Score
 * gray, the rest a 1px pt-off ring. Fixed grids are allowed only here and in
 * the 100-point Guardian Score waffle (Proportional Chart Rule). An image
 * named "{earned} of {total} points" unless given a `label`.
 */
import clsx from 'clsx'
import { TONE_BG } from './tones'
import type { Category } from './types'

export interface PointGridProps {
  /** Points earned; rounded and clamped to the grid. */
  earned: number
  total?: number
  /** The fill for earned points. Default `secure`. */
  category?: Category
  label?: string
  className?: string
}

export function PointGrid({ earned, total = 30, category = 'secure', label, className }: PointGridProps) {
  const size = Math.max(0, Math.round(total))
  const on = Math.min(size, Math.max(0, Math.round(earned)))
  return (
    <div
      role="img"
      aria-label={label ?? `${on} of ${size} points`}
      className={clsx('grid w-max grid-cols-[repeat(10,10px)] gap-0.5', className)}
    >
      {Array.from({ length: size }, (_, i) => (
        <span key={i} className={clsx('h-2.5 w-2.5', i < on ? TONE_BG[category] : 'ring-1 ring-inset ring-cat-off')} />
      ))}
    </div>
  )
}

export default PointGrid
